/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { updateMarginMode } from 'actions/trade';
import { MARGIN_TYPES } from 'constants/constants';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { capitalize, noop } from 'helpers/utils';
import useToggle from 'hooks/useToggle';
import {
  portfolioEnableMinBalanceSelector,
  userMarginModeSelector,
  userSelector,
  maxAccountsSelector,
} from 'selectors/otherSelectors';
// import { Info } from 'styles/assets/icons';

import styles from '../leverage.module.scss';
import {
  ActionButtons,
  MarginModeInfo,
  ErrorMsg,
  // CrossMarginRequestAccess,
} from './helpers';
import { ButtonFooter, PortfolioWrapper } from './styles';
// import RangeSlider from '../../rangeSlider';
// import MaxNotional from '../MaxNotional';

const PortfolioMargin = props => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['common']);

  const {
    submit,
    onCancel,
    isSubAccountCreate,
    setMarginMode,
    subAccountUser,
    margin_mode,
    goBack,
  } = props;

  const [loading, toggleLoading] = useToggle(false);
  const user = useSelector(userSelector);
  const accountLimits = useSelector(maxAccountsSelector);

  const portfolioEnableMinBalance = useSelector(state =>
    portfolioEnableMinBalanceSelector(state)
  );

  const [errorCode, setErrorCode] = useState('');

  const setMarginType = marginMode => {
    const obj = {
      margin_mode: marginMode,
      // eslint-disable-next-line react/prop-types
      user_id: subAccountUser?.user_id || user.id,
    };
    toggleLoading();
    dispatch(updateMarginMode(obj))
      .then(() => {
        trackMixpanelEvent('Account Margin Mode Changed', {
          account_name: user.account_name,
          margin_mode: MARGIN_TYPES.PORTFOLIO,
        });
        submit();
        // this.setMarginType(MARGIN_TYPES.PORTFOLIO);
        setErrorCode('');
        // setShowConfirm(false);
        onCancel?.();
        goBack?.();
      })
      .catch(err => {
        const { error } = err.response.body;
        setErrorCode(error.code);
        // setShowConfirm(false);
      })
      .finally(() => toggleLoading());
  };

  const onSubmit = () => {
    if (isSubAccountCreate) {
      setMarginMode({
        margin_mode: MARGIN_TYPES.PORTFOLIO,
      });
    } else {
      setMarginType(MARGIN_TYPES.PORTFOLIO);
    }
    // Hide the popup
    // submit();
  };

  const shouldAllowCreate =
    accountLimits[MARGIN_TYPES.PORTFOLIO] >
    // eslint-disable-next-line react/prop-types
    (accountLimits?.currentLimits[MARGIN_TYPES.PORTFOLIO] || 0);

  let makeApiCall = false;

  const ctaText = (() => {
    // const selectedMarginMode = user.margin_mode;
    // pf mode
    if (margin_mode && margin_mode === MARGIN_TYPES.PORTFOLIO) {
      makeApiCall = false;
      return t('common:continueWithMarginMode', {
        current_margin_mode: capitalize(margin_mode),
      });
    }

    makeApiCall = true;
    return t('common:switchToMarginMode', {
      new_margin_mode: capitalize(MARGIN_TYPES.PORTFOLIO),
    });
  })();

  const disableSubmit = !shouldAllowCreate;

  return (
    // rawAssets: used this prop as we need the original object on switching the coin
    (<PortfolioWrapper>
      {!shouldAllowCreate && (
        <div className="error-container" data-palette="PortfolioMargin">
          <ErrorMsg
            additionalContext={{
              accountLimits,
              marginMode: MARGIN_TYPES.PORTFOLIO,
            }}
            error_code="account_limit_reached"
          />
        </div>
      )}
      <div className="margin-mode-info">
        <MarginModeInfo margin_mode="portfolio" />
      </div>
      {errorCode && (
        <ErrorMsg
          error_code={errorCode}
          additionalContext={{
            portfolioEnableMinBalance,
            accountLimits,
            marginMode: MARGIN_TYPES.PORTFOLIO,
          }}
        />
      )}
      <ButtonFooter>
        <ActionButtons
          submit={onSubmit}
          onCancel={onCancel}
          disableSubmit={disableSubmit}
          loading={loading}
          // className="portfolio-mode-button"
          marginType={MARGIN_TYPES.PORTFOLIO}
          currentMarginMode={user.margin_mode}
          ctaText={ctaText}
          makeApiCall={makeApiCall}
        />
      </ButtonFooter>
      {/* {!showAssetSelection && !changeAssetSelection && (
        <>




          <ActionButtons
            submit={submit}
            onCancel={onCancel}
            t={t}
            disableSubmit={available_balance < portfolioEnableMinBalance}
          />
        </>
      )} */}
      {/* {!showAssetSelection && !changeAssetSelection && (
        <div
          className="accordion-wrapper"
          onClick={() => setShowAccordion(!showAccordion)}>
          <div className="accordion-title">
            {t('portfolioMargin:what_is_portfolio')}
            <span className={showAccordion ? 'active' : ''}>
              <GreyArrowDown />
            </span>
          </div>
          {showAccordion && (
            <div className="slider">
              {t('portfolioMargin:what_is_portfolio_desc')}
            </div>
          )}
        </div>
      )} */}
    </PortfolioWrapper>)
  );
};

PortfolioMargin.propTypes = {
  submit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  setMarginMode: PropTypes.func.isRequired,
  isSubAccountCreate: PropTypes.bool,
  subAccountUser: PropTypes.shape({}),
};

const IsolatedMargin = props => {
  const {
    margin_mode, // this is margin mode selected in popup
    onSubmit,
    onCancel,
    subAccountMarginMode,
    isolatedError,
    isCrossMargin,
  } = props;
  const { t } = useTranslation(['common']);
  const accountLimits = useSelector(maxAccountsSelector);

  const [loading, setLoading] = useState(false);

  const currentMarginMode = isCrossMargin ? MARGIN_TYPES.CROSS : MARGIN_TYPES.ISOLATED;
  const shouldAllowCreate =
    (margin_mode || subAccountMarginMode) &&
    accountLimits[currentMarginMode] !== accountLimits?.currentLimits[currentMarginMode];

  // const [loading, toggleLoading] = useToggle(false);
  const marginMode = useSelector(userMarginModeSelector);
  // const user = useSelector(userSelector);
  // const { cross_margin_enabled } = user?.profile || {};

  useEffect(() => {
    if (isolatedError?.code) {
      setLoading(false);
    }
  }, [isolatedError?.code]);

  const submit = () => {
    setLoading(true);
    onSubmit(currentMarginMode);
  };

  const CTAText = (() => {
    if (margin_mode && margin_mode === currentMarginMode) {
      return t('common:continueWithMarginMode', {
        current_margin_mode: capitalize(currentMarginMode),
      });
    }
    if (margin_mode && margin_mode !== currentMarginMode) {
      return t('common:switchToMarginMode', {
        new_margin_mode: capitalize(currentMarginMode),
      });
    }
    return noop;
  })();

  const disableSubmit = !shouldAllowCreate && margin_mode !== currentMarginMode;

  return (
    (<div className={styles[`isolated-container`]} data-palette="IsolatedMargin">
      {!shouldAllowCreate && margin_mode !== currentMarginMode && (
        <div className={styles[`error-container`]} data-palette="IsolatedMargin">
          <ErrorMsg
            additionalContext={{
              accountLimits,
              marginMode: currentMarginMode,
            }}
            error_code="account_limit_reached"
          />
        </div>
      )}
      <div className={styles[`margin-mode-info`]}>
        <MarginModeInfo margin_mode={currentMarginMode} />
      </div>
      {/* eslint-disable-next-line react/prop-types */}
      {isolatedError?.code && (
        <div
          className={cn(styles[`error-container`], styles[`error-bottom`])}
          data-palette="IsolatedMargin">
          <ErrorMsg
            additionalContext={{
              accountLimits,
              marginMode: currentMarginMode,
            }}
            // eslint-disable-next-line react/prop-types
            error_code={isolatedError.code}
          />
        </div>
      )}
      <ButtonFooter>
        <ActionButtons
          submit={submit}
          onCancel={onCancel}
          loading={loading}
          disableSubmit={disableSubmit}
          hasChanged={
            shouldAllowCreate &&
            ((subAccountMarginMode && subAccountMarginMode !== currentMarginMode) ||
              margin_mode !== currentMarginMode)
          }
          currentMarginMode={marginMode}
          ctaText={CTAText}
          makeApiCall={
            shouldAllowCreate &&
            ((subAccountMarginMode && subAccountMarginMode !== currentMarginMode) ||
              margin_mode !== currentMarginMode)
          }
        />
      </ButtonFooter>
      {/* {isCrossMargin && !cross_margin_enabled && <CrossMarginRequestAccess />} */}
    </div>)
  );
};

IsolatedMargin.propTypes = {
  margin_mode: PropTypes.string,
  subAccountMarginMode: PropTypes.string,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  isCrossMargin: PropTypes.bool,
  isolatedError: PropTypes.shape({}),
};

const CrossMargin = props => {
  const { margin_mode, onSubmit, onCancel, subAccountMarginMode, isolatedError } = props;
  return (
    <IsolatedMargin
      data-testid="isolatedMarginComponent"
      margin_mode={margin_mode}
      subAccountMarginMode={subAccountMarginMode}
      onCancel={onCancel}
      onSubmit={onSubmit}
      isolatedError={isolatedError}
      isCrossMargin
    />
  );
};

CrossMargin.propTypes = {
  margin_mode: PropTypes.string,
  subAccountMarginMode: PropTypes.string,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  isolatedError: PropTypes.shape({}),
};

export { PortfolioMargin, IsolatedMargin, CrossMargin };
